import { render } from "./WhatsAppOTPComponent.vue?vue&type=template&id=49e576ea&scoped=true"
import script from "./WhatsAppOTPComponent.vue?vue&type=script&lang=js"
export * from "./WhatsAppOTPComponent.vue?vue&type=script&lang=js"

import "./WhatsAppOTPComponent.vue?vue&type=style&index=0&id=49e576ea&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49e576ea"]])

export default __exports__